/*
 * Copyright (c) 2019. K+S France & Isagri Ingénierie
 * SD version du 05/06/2020 18:16:45
 */

import Vue from "vue";
import Vuex from "vuex";

// pour éviter d'avoir juste une instance d'axios qui n'a pas la méthode .all
const axios = require("axios");

Vue.use(Vuex);

export default new Vuex.Store({
  //
  // Le state est le stockage centralisé de l'information dont les données sont partagées entre tous les composants de l'application
  //
  state: {
    // les paramètres de l'application
    easyfert: {
      loadData: true,
      routes: [],
      maxReco: 140
    },
    // les données du formulaire
    formulaire: {
      yield: {
        culture: null,
        yield: 0,
        neads: null
      },

      contribution: {
        contributionEnabled: false,
        contributionType: null,
        contributionQuantity: 0,
        residuesEnabled: false,
        residuesCulture: null,
        residuesYield: 0,
        residuesUsed: 0,
        n: 0,
        p2o5: 0,
        k2o: 0,
        mgo: 0,
        so3: 0,
        residue: {}
      },

      ground: {
        wealf: {
          mgo: null,
          k2o: null
        },
        ph: null
      },

      synthesis: {
        potassiumForm: "chlorure" // valeur par défaut
      },

      recommandation: {
        k2o: 0,
        k2o_max: 0,
        mgo: 0,
        mgo_max: 0,
        so3: 0,
        so3_max: 0,
        ab: false,
        apport_h_k2o: 0,
        apport_h_mgo: 0,
        apport_h_so3: 0,
        lesRecommandations: null
      }
    },
    reco: {},
    report: {},
    // les données de référence serant au calcul
    ref: {
      cultures: null,
      apports: null,
      sols: {
        ground_ph: [],
        ground_levels: []
      }
    }
  },
  //
  // Les mutations (modifies les data ds le store
  // elles ne doivent être appelées que depuis le store
  //
  mutations: {
    //
    // Mutations sur les routes
    //
    STORE_ROUTES(state, routes) {
      state.easyfert.routes = routes || [];
    },
    RAZ_ROUTES(state) {
      try {
        state.easyfert.routes.forEach(route => {
          if (route.order > 1 && route.order < 6) {
            route.enabled = false;
          } else {
            route.enabled = true;
          }
        });
      } catch (e) {
        console.error("Erreur durant le reset des routes ", e);
      }
      console.info("RAZ ROUTE done");
    },
    UPDATE_ROUTES(state, routes) {
      try {
        state.easyfert.routes.forEach((route, index) => {
          if (route.order > 1 && route.order < 6) {
            route.enabled = routes[index];
          } else {
            route.enabled = true;
          }
        });
        console.info("UPDATE_ROUTES done");
      } catch (e) {
        console.error("Erreur à la mise à jour des routes : ", e);
      }
    },
    //
    // Reset et initialisation des données de référence du formulaire
    //
    FETCH_ALLDATA(state, value) {
      state.easyfert.loadData = value;
      console.info("Toutes les données chargées");
    },
    RAZ_FORMS(state) {
      state.formulaire.yield.culture = null;
      state.formulaire.yield.yield = 0;
      state.formulaire.yield.neads = null;

      state.formulaire.contribution.contributionEnabled = false;
      state.formulaire.contribution.contributionType = null;
      state.formulaire.contribution.contributionQuantity = 0;
      state.formulaire.contribution.residuesEnabled = false;
      state.formulaire.contribution.residuesCulture = null;
      state.formulaire.contribution.residuesYield = 0;
      state.formulaire.contribution.residuesUsed = 0;
      state.formulaire.contribution.n = 0;
      state.formulaire.contribution.p = 0;
      state.formulaire.contribution.k = 0;
      state.formulaire.contribution.m = 0;
      state.formulaire.contribution.s = 0;

      state.formulaire.ground.wealf.k2o = null;
      state.formulaire.ground.wealf.mgo = null;
      state.formulaire.ground.ph = null;

      state.formulaire.synthesis.potassiumForm = "chlorure";

      state.formulaire.recommandation.k2o = 0;
      state.formulaire.recommandation.k2o_max = 0;
      state.formulaire.recommandation.mgo = 0;
      state.formulaire.recommandation.mgo_max = 0;
      state.formulaire.recommandation.so3 = 0;
      state.formulaire.recommandation.so3_max = 0;
      state.formulaire.recommandation.lesRecommandations = null;
      state.formulaire.recommandation.ab = false;

      console.info("RAZ FORM done");
    },
    FETCH_CULTURES(state, cultures) {
      state.ref.cultures = cultures || [];
      console.info("FETCH_CULTURE done");
    },
    FETCH_APPORTS(state, apports) {
      state.ref.apports = apports || [];
      console.info("FETCH_APPORTS done");
    },
    FETCH_SOLS(state, sols) {
      state.ref.sols = sols || [];
      console.info("FETCH_SOLS done");
    },
    FETCH_PHRASES(state, phrases) {
      state.ref.phrases = phrases || [];
      console.info("FETCH_PHRASES done");
    },
    FETCH_PRECOS(state, recommandations) {
      console.dir(recommandations);
      if (recommandations !== null) {
        console.log("Recommandations non nulles");
        if (recommandations.chlorure === null) {
          console.log("Chlorure nulle");
          recommandations.chlorure = {
            alternative: {
              produit_complement: {
                nom: "",
                dose: 0
              },
              produit_principal: {
                nom: "",
                dose: 0
              }
            },
            choix_final: {
              produit_complement: {
                nom: "",
                dose: 0
              },
              produit_principal: {
                nom: "",
                dose: 0
              }
            }
          };
        }
        if (recommandations.sulfate === null) {
          console.log("sulfate nulle");
          recommandations.sulfate = {
            alternative: {
              produit_complement: {
                nom: "",
                dose: 0
              },
              produit_principal: {
                nom: "",
                dose: 0
              }
            },
            choix_final: {
              produit_complement: {
                nom: "",
                dose: 0
              },
              produit_principal: {
                nom: "",
                dose: 0
              }
            }
          };
          recommandations.chlorure = {
            alternative: {
              produit_complement: {
                nom: "",
                dose: 0
              },
              produit_principal: {
                nom: "",
                dose: 0
              }
            },
            choix_final: {
              produit_complement: {
                nom: "",
                dose: 0
              },
              produit_principal: {
                nom: "",
                dose: 0
              }
            }
          };
        }
      } else {
        console.log("Recommandations nulles");
        recommandations.sulfate = {
          alternative: {
            produit_complement: {
              nom: "",
              dose: 0
            },
            produit_principal: {
              nom: "",
              dose: 0
            }
          },
          choix_final: {
            produit_complement: {
              nom: "",
              dose: 0
            },
            produit_principal: {
              nom: "",
              dose: 0
            }
          }
        };
        recommandations.chlorure = {
          alternative: {
            produit_complement: {
              nom: "",
              dose: 0
            },
            produit_principal: {
              nom: "",
              dose: 0
            }
          },
          choix_final: {
            produit_complement: {
              nom: "",
              dose: 0
            },
            produit_principal: {
              nom: "",
              dose: 0
            }
          }
        };
      }
      console.dir(recommandations);
      state.formulaire.recommandation.lesRecommandations = recommandations;
      console.info("FETCH_PRECOS done");
    },
    //
    // Stockage des données du formulaire
    //
    STORE_YIELD(state, yieldForm) {
      state.formulaire.yield = { ...yieldForm };
      console.info("Store yieldForm done");
    },
    SWITCH_CONTRIBUTION(state) {
      state.formulaire.contribution.contributionEnabled = !state.formulaire
        .contribution.contributionEnabled;
      console.info("Switch contribution done");
    },
    SWITCH_RESIDUE(state) {
      state.formulaire.contribution.residuesEnabled = !state.formulaire
        .contribution.residuesEnabled;
      console.info("Switch residues done");
    },
    STORE_CONTRIBUTION(state, contributionForm) {
      state.formulaire.contribution.contributionType =
        contributionForm.contributionType;
      state.formulaire.contribution.contributionQuantity =
        contributionForm.contributionQuantity;
      console.info("Store contribution done");
    },
    STORE_RESIDUES(state, residuesForm) {
      state.formulaire.contribution.residuesCulture =
        residuesForm.residuesCulture;
      state.formulaire.contribution.residuesYield = residuesForm.residuesYield;
      state.formulaire.contribution.residuesUsed = residuesForm.residuesUsed;
      console.info("Store residues done");
    },
    STORE_GROUND(state, ground) {
      state.formulaire.ground.ph = ground.ph;
      state.formulaire.ground.wealf = ground.wealf;
      console.info("Store ground done");
    },
    STORE_RECO(state, reco) {
      state.reco = reco;
      console.log(reco);
      reco.produits = [reco.formule.reco.produit_principal.nomreflist, reco.formule.reco.produit_complement.nomreflist];
      console.info("Store reco done");
    },
    STORE_URL(state, email) {
      state.report = email;
      console.info("Stockage email ok");
    },
    //
    // Synthèse
    //
    CALC_SYNTHESIS(state) {
      // 1 calcul de la synthèse
      const contributions = { n: 0, p2o5: 0, k2o: 0, mgo: 0, so3: 0 }, // apports organiques
            residues = { n: 0, p2o5: 0, k2o: 0, mgo: 0, so3: 0 }, // résidus de culture précédente
            besoins = {...state.formulaire.yield.neads}; // les besoins initialisés avec la valeur calculé initialement

      if (state.formulaire.contribution.contributionEnabled) {
        // contributions.n = Math.round(state.formulaire.contribution.contributionType.n * state.formulaire.contribution.contributionQuantity);
        // contributions.p2o5 = Math.round(state.formulaire.contribution.contributionType.p2o5 * state.formulaire.contribution.contributionQuantity);
        contributions.k2o =
          state.formulaire.contribution.contributionType.k2o *
          state.formulaire.contribution.contributionQuantity;
        contributions.mgo =
          state.formulaire.contribution.contributionType.mgo *
          state.formulaire.contribution.contributionQuantity;
        contributions.so3 =
          state.formulaire.contribution.contributionType.so3 *
          state.formulaire.contribution.contributionQuantity;
      }
      if (state.formulaire.contribution.residuesEnabled) {
        // residues.n = Math.round(state.formulaire.contribution.residuesCulture.r_n * state.formulaire.contribution.residuesUsed);
        // residues.p2o5 = Math.round(state.formulaire.contribution.residuesCulture.r_p2o5 * state.formulaire.contribution.residuesUsed);
        residues.k2o =
          state.formulaire.contribution.residuesCulture.r_k2o *
          state.formulaire.contribution.residuesUsed;
        residues.mgo =
          state.formulaire.contribution.residuesCulture.r_mgo *
          state.formulaire.contribution.residuesUsed;
        residues.so3 =
          state.formulaire.contribution.residuesCulture.r_so3 *
          state.formulaire.contribution.residuesUsed;

        state.formulaire.contribution.residue = {...residues}

      }

      // console.log("Contributions", contributions);
      // state.formulaire.contribution.n = contributions.n + residues.n;
      // state.formulaire.contribution.p2o5 = contributions.p2o5 + residues.p2o5;
      state.formulaire.contribution.k2o = contributions.k2o;
      state.formulaire.contribution.mgo = contributions.mgo;
      state.formulaire.contribution.so3 = contributions.so3;

      // Calcul des besoin en apport minéraux pour complétion à 100%
      // Si les résidues sont été exportés alors les valeurs sont ajoutées aux besoins
      if (state.formulaire.contribution.residuesEnabled) {
        besoins.k2o = state.formulaire.yield.neads.k2o + residues.k2o;
        besoins.mgo = state.formulaire.yield.neads.mgo + residues.mgo;
        besoins.so3 = state.formulaire.yield.neads.so3 + residues.so3;
      }

      const k2o_0 =
        (besoins.k2o - state.formulaire.contribution.k2o) *
        state.formulaire.ground.wealf.k2o;
      if (k2o_0 > 0) {
        state.formulaire.recommandation.k2o = k2o_0;
      } else {
        state.formulaire.recommandation.k2o = 0;
      }

      // console.log(k2o_0);
      // calcul de la valeur à max%
      state.formulaire.recommandation.k2o_max =
        (besoins.k2o * state.easyfert.maxReco) / 100;

      // calcul mgo
      const mgo_0 =
        (besoins.mgo - state.formulaire.contribution.mgo) *
        state.formulaire.ground.wealf.mgo;
      if (state.formulaire.ground.ph === 1) {
        state.formulaire.recommandation.mgo = mgo_0;
      } else {
        state.formulaire.recommandation.mgo = mgo_0 * 1.5;
      }

      if (state.formulaire.recommandation.mgo < 0) {
        state.formulaire.recommandation.mgo = 0;
      }
      // calcul de la valeur à max%
      state.formulaire.recommandation.mgo_max =
        (besoins.mgo * state.easyfert.maxReco) / 100;

      // calcul so3
      state.formulaire.recommandation.so3 =
        besoins.so3 - state.formulaire.contribution.so3;
      // calcul de la valeur à max%
      state.formulaire.recommandation.so3_max =
        (besoins.so3 * state.easyfert.maxReco) / 100;
    },
    STORE_POTASSIUMFORM(state, form) {
      state.formulaire.synthesis.potassiumForm = form;
    }
  },
  //
  // les getters extraient des informations du store
  //
  getters: {
    getCulture: state => laCulture => {
      return state.ref.cultures.find(i => i.culture === laCulture);
    },
    getCulturesList: state => {
      return state.ref.cultures;
    },
    getContributionList: state => {
      return state.ref.apports;
    },
    getNeads: state => {
      // si les résidues sont exportés alors ils sont ajoutés aux besoins
      if (state.formulaire.contribution.residuesEnabled) {
        const n_k2o = state.formulaire.yield.neads.k2o + state.formulaire.contribution.residue.k2o;
        const n_mgo = state.formulaire.yield.neads.mgo + state.formulaire.contribution.residue.mgo;
        const n_so3 = state.formulaire.yield.neads.so3 + state.formulaire.contribution.residue.so3;
        return { k2o: n_k2o, mgo: n_mgo, so3: n_so3 };
      } else {
        return state.formulaire.yield.neads;
      }
    },
    getRouteOrder: state => currentRoute => {
      return state.easyfert.routes.find(i => i.path === currentRoute).order;
    },
    getContributionEnabled: state => {
      return !state.formulaire.contribution.contributionEnabled;
    },
    getResiduesEnabled: state => {
      return !state.formulaire.contribution.residuesEnabled;
    },
    getResiduesYieldEnabled: state => {
      return state.formulaire.contribution.residuesYieldEnabled;
    },
    getGroundLevelsLabels: state => {
      try {
        return state.ref.sols.ground_levels.map(e => e[0]).reverse();
      } catch (error) {
        console.error("In Store etGroundLevelsLabels ", error);
      }
    },
    getGroundPh: state => {
      return state.ref.sols.ground_ph;
    },
    getSynthesis: state => {
      return state.formulaire.contribution;
    },
    getRecommandation: state => {
      return state.formulaire.recommandation;
    },
    getPotassium: state => {
      return state.formulaire.synthesis.potassiumForm;
    },
    getPhraseId: state => id => {
      try {
        return state.ref.phrases.find(i => i.id === id).phrase;
      } catch (e) {
       return false;
      }
    }
  },
  //
  // les actions sont appellées depuis les composants
  // c'est elles qui appellent les mutations
  //
  actions: {
    // getData charge les données de référence dans le store depuis des web service
    getData({ commit }) {
      // Récupération des informations
          try {
              const version = new Date().toISOString().slice(0, 10);
              return axios
                  .get(`${process.env.VUE_APP_URLDATA}jsonData/ref_easyfert.json?v=${version}`)
                  .then(function (reponse) {
                      console.log(reponse.data.referentiel_easyfert);
                      try {
                          commit(
                              "FETCH_CULTURES",
                              reponse.data.referentiel_easyfert.cultures
                          );
                          commit(
                              "FETCH_APPORTS",
                              reponse.data.referentiel_easyfert.apports
                          );
                          commit("FETCH_SOLS", reponse.data.referentiel_easyfert.sols);
                          commit(
                              "FETCH_PHRASES",
                              reponse.data.referentiel_easyfert.phrases
                          );
                          commit("FETCH_ALLDATA", false); // à toujour placer en dernier
                      } catch (error) {
                          console.error(error);
                      }
                  })
                  .catch(error => console.error(error));
          } catch (e) {
              alert(e);
          }

      //});
    }, // getData
    // setRoute charge dans le store les routes de l'application (gérées par le router)
    setRoutes({ commit }, routes) {
      try {
        commit("STORE_ROUTES", routes);
      } catch (e) {
        console.error("L'enregistrement des routes a faillit", e);
      }
    },
    // Remet les routes à l'état initial (retour à la page d'accueil pour refaire une simulation
    razRoutes({ commit }) {
      commit("RAZ_ROUTES");
    },

    // demande la réinitialisation du formulaire
    razForms({ commit }) {
      commit("RAZ_FORMS");
    },
    // updateRoute met à jour les données des route au fur et à mesure que l'utilisateur chemine dans le formulaire
    updateRoutes({ commit, state }, currentMenu) {
      //const currentMenu = this.$router.currentRoute.path;
      const currentOrder = state.easyfert.routes.find(
        i => i.path === currentMenu
      ).order;
      console.log("Current Menu", currentOrder);
      const routes = state.easyfert.routes.map(route => {
        return route.order < currentOrder + 1
          ? (route.enabled = true)
          : (route.enabled = false);
      });
      console.log("Les routes ", routes);

      commit("UPDATE_ROUTES", routes);
    },

    //
    // Début des actions propres aux pages du formulaire
    //
    // setYieldNeads calcule et inscrit dans le store les valeurs des besoins (écran de rendement)
    setYieldNeads({ commit }, yieldObject) {
      yieldObject.neads.n = yieldObject.culture.cp_n * yieldObject.yield;
      yieldObject.neads.k2o = yieldObject.culture.cp_k2o * yieldObject.yield;
      yieldObject.neads.mgo = yieldObject.culture.cp_mgo * yieldObject.yield;
      yieldObject.neads.p2o5 = yieldObject.culture.cp_p2o5 * yieldObject.yield;
      if (yieldObject.culture.culture === "Colza oléagineux") {
        yieldObject.neads.so3 = 75;
      } else {
        yieldObject.neads.so3 = yieldObject.culture.cp_so3 * yieldObject.yield;
      }
      commit("STORE_YIELD", yieldObject);
    },

    //
    //  demande l'activation ou la desactivation des nextScreen
    switchContribution({ commit }) {
      commit("SWITCH_CONTRIBUTION");
    },
    switchResidue({ commit }) {
      commit("SWITCH_RESIDUE");
    },

    //
    // demande le stokage des nextScreen
    storeContribution({ commit }, contributionObject) {
      console.log(contributionObject);
      commit("STORE_CONTRIBUTION", contributionObject);
    },

    //
    // demande le stokage des nextScreen
    storeResidues({ commit }, residuesObject) {
      console.log(residuesObject);
      commit("STORE_RESIDUES", residuesObject);
    },
    //
    // demande le stokage de la richesse du sol
    storeGround({ commit, state }, ground) {
      // ground.wealf.k2o = (ground.wealf.k2o === "undefined") ? 0 : ground.wealf.k2o;
      // ground.wealf.mgo = (ground.wealf.mgo === "undefined") ? 0 : ground.wealf.mgo;

      ground.wealf.k2o = this.state.ref.sols.ground_levels[ground.wealf.k2o][1];
      ground.wealf.mgo = this.state.ref.sols.ground_levels[ground.wealf.mgo][1];


      console.dir(ground);
      commit("STORE_GROUND", ground);
    },
    //
    storeReco({ commit, store }, reco) {
      console.log(reco);
      let laReco = {
        yield: this.state.formulaire.yield,
        ground: this.state.formulaire.ground,
        contribution: this.state.formulaire.contribution,
        recommandation: {
          k2o: this.state.formulaire.recommandation.k2o,
          k2o_max: this.state.formulaire.recommandation.k2o_max,
          mgo: this.state.formulaire.recommandation.mgo,
          mgo_max: this.state.formulaire.recommandation.mgo_max,
          so3: this.state.formulaire.recommandation.so3,
          so3_max: this.state.formulaire.recommandation.so3_max
        },
        formule: reco
      };
      commit("STORE_RECO", laReco);
    },
    // calcul de la synthèse
    calcSynthesis({ commit }) {
      commit("CALC_SYNTHESIS");
    },
    //
    // stokage de la forme du potassium
    storePotassiumForm({ commit }, form) {
      commit("STORE_POTASSIUMFORM", form);
    },
    //
    // appel au moteur côté serveur
    motor({ commit }, params) {
      //console.log(JSON.stringify(params));
      return axios
        .post(
          `${process.env.VUE_APP_URLAPI}Modules/easyfert/WSEasyfert.asmx/MoteurRecommandation`,
          params
        )
        .then(
          function success(reponse) {
            //console.dir(JSON.parse(reponse.data.d).recommandation);
            try {
              commit("FETCH_PRECOS", JSON.parse(reponse.data.d).recommandation);
              console.info("commit des preco");
            } catch {
              console.error("Erreur durant le stockage des valeurs");
            }
          },
          function fail(message) {
            alert("Une erreur réseau est survenue à la récupération des recommandations : ", message);
          }
        );
    },

    sendRepport({commit, state}, email) {
      const param = {
        email: email,
        recommandation: {
          yield: state.reco.yield,
          contribution: state.reco.contribution,
          ground: state.reco.ground,
          formule: state.reco.formule,
          recommandation: state.reco.recommandation
        },
        produits: state.reco.produits
      };


      return axios.post(`${process.env.VUE_APP_URLAPI}Modules/easyfert/WSEasyfert.asmx/SaveReport`, param).then(
          function success(reponse) {
            commit("STORE_URL", reponse);
            return {flag: true, message: reponse.data.d};
          },
          function fail(message){
            return {flag: false, message: message}
          }
      )
    }
  }
});
